import React from "react";
import PropTypes from "prop-types";
import StyledColorSelector from "./ColorSelector.styled";
import styled from "styled-components";

const StyledContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, 24px);
  grid-gap: 8px;
  align-items: center;
  flex: 1;
`;

const ColorSelector = React.memo(props => {
  const { children, onSelectProp, productId, childId, className } = props;

  return (
   <StyledContainer className={className}>
        {children && children.length ?
            children.map(item=>
                <StyledColorSelector
                    className={ childId && item.id === childId ? 'selected' : (!childId && productId && item.id === productId) ? 'selected' :''}
                    color={item.variation}
                    key={item.id}
                    onClick={() => onSelectProp(item) }
                    opacity={Number(item.quantity) ? "1" : "0.3"}
                >
                     <span className="t-hidden">{item.variation}</span>
                </StyledColorSelector>
            )
        :''}
   </StyledContainer>
  );
});

ColorSelector.propTypes = {
  children: PropTypes.array,
  onSelectProp: PropTypes.func,
  productId: PropTypes.string,
  childId: PropTypes.string,
  className: PropTypes.string,
};

export default ColorSelector;